import React, {useState, createContext, useContext} from 'react'
import {MsgBox} from '../../app/components/modals/MsgBox'
import {IModalProps, IModalStore} from '../../app/modules/core/models/Base'
import {GlobalModalContextType} from '../../app/modules/core/state/types'

const initalState: GlobalModalContextType = {
  showModal: () => {},
  hideModal: () => {},
  store: {isShow: false},
}

const GlobalModalContext = createContext(initalState)
export const useGlobalModalContext = () => useContext(GlobalModalContext)

export const GlobalModal: React.FC<{ children?: React.ReactNode}> = ({children}) => {
  const [store, setStore] = useState<IModalStore>({
    isShow: false,
  })


  const showModal = (modalProps?: IModalProps,  onClickCallBack?:any ) => {
    setStore({
      ...store,
      isShow: true,
      modalProps,
      onClickCallBack:onClickCallBack 
    })
  
  }

  const hideModal = () => {
    setStore({
      ...store,
      isShow: false,
      modalProps: undefined,
    })
  }

  return (
    <GlobalModalContext.Provider value={{store, showModal, hideModal}}>
      {store.isShow && <MsgBox />}
      {children}
    </GlobalModalContext.Provider>
  )
}
